/* @flow */
import Store from 'lib/Store';
import { ActionTypes as BlockedUserActionTypes } from 'constants/BlockedUserConstants';
import BlockedUsers from 'collections/BlockedUsers';
import { ActionTypes as RelationshipActionTypes } from 'constants/RelationshipConstants';

class BlockedUserStore extends Store {
  getInitialState() {
    return {
      blockedUsers: new BlockedUsers(),
      loaded: false,
    };
  }

  isLoaded() {
    return this.state.loaded;
  }

  getBlockedUsers() {
    return this.state.blockedUsers;
  }

  removeBlockedUser(blockedUser) {
    this.state.blockedUsers.remove(blockedUser);
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case BlockedUserActionTypes.LOAD_BLOCKED_USERS:
        this.handleLoad(action.blockedUsers);
        break;
      case RelationshipActionTypes.UPDATE_RELATIONSHIP:
        this.handleRelationshipUpdate(action.relationship);
        break;
      default:
        break;
    }
  }

  handleRelationshipUpdate(relationship) {
    const relatedUser = relationship.getRelatedUser();
    if (relatedUser.isBlocked()) {
      this.state.loaded = false;
    } else {
      this.removeBlockedUser(relatedUser);
    }
    this.emitChange();
  }

  handleLoad(blockedUsers) {
    this.state.blockedUsers.reset(blockedUsers.models);
    this.state.loaded = true;
    this.emitChange();
  }
}

export default new BlockedUserStore();



// WEBPACK FOOTER //
// ./src/settings/stores/BlockedUserStore.js